import { RootState } from "@/store";

export const selectTransferState = (state: RootState) => state.transfer;
